import { NavigateLink } from '@/components/navigate/NavigateLinks';
import { NavigateFunction } from 'react-router-dom';

export const commercePageBreadcrumbs = (
  navigate: NavigateFunction
): NavigateLink[] => [
  { label: 'Inicio', onClick: () => navigate('/') },
  { label: 'Sistema de envíos', onClick: () => navigate('/business') },
  {
    label: 'Red logística',
    onClick: () => navigate('/business/logistics-network'),
  },
  { label: 'Comercios', onClick: () => navigate('/business/commerce') },
];

export const childrenCommercePageBreadcrumbs = (
  navigate: NavigateFunction,
  commerceId: string,
  commerceName?: string
): NavigateLink[] => [
  ...commercePageBreadcrumbs(navigate),
  {
    label: commerceName || 'Comercio',
    onClick: () => navigate(`/business/commerce/${commerceId}/dashboard`),
  },
];
